import graphql__49c4a7d4fa7d2b286008 from "./__generated__/ContributionsMapThemeBox_theme.graphql.js";import { useState, useCallback } from "react";
import { graphql, useFragment } from "react-relay";
import { useDispatch } from "react-redux";

import MapElementImage from "../../../Maps/MapElementImage";
import Button from "../../../Buttons/Button";
import Icon from "../../../Utils/Icon";
import { useResourcesList } from "../../../ResourcesList/resourcesList";

import { updateSelectedThemes } from "../../../../reducers/resourcesList/search";

const ContributionsMapThemeBox = props => {
  const theme = useFragment(ContributionsMapThemeBox_theme, props.theme);

  const [isHover, setIsHover] = useState(false);

  const onMouseEnter = () => setIsHover(true);
  const onMouseLeave = () => setIsHover(false);

  const { id: themeId, name, primaryColor, style } = theme;

  const { resourcesListKey, search } = useResourcesList();
  const { selectedThemes } = search;

  const isSelected = selectedThemes.some(({ id }) => id === themeId);

  const dispatch = useDispatch();
  const handleClick = useCallback(() => {
    const newSelectedThemes = isSelected ? [] : [theme];
    dispatch(updateSelectedThemes(resourcesListKey, newSelectedThemes));
  }, [dispatch, isSelected, resourcesListKey, theme]);

  const backgroundColor = isHover || isSelected ? primaryColor : "white";
  const color = isHover || isSelected ? "white" : primaryColor;

  const filterIconClassName = isSelected ? "icon-close" : "icon-funnel";

  return (
    <Button
      className="map-sidebar-element map-sidebar-theme box padding-sm btn-unstyled btn-block text-left d-flex align-items-center"
      style={{ backgroundColor, color }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={handleClick}
    >
      <div
        className="text-left margin-right-xs"
        dangerouslySetInnerHTML={{
          __html: MapElementImage({
            ...style,
            position: "static",
            className: "map-sidebar-element-icon"
          })
        }}
      />

      <div className="map-sidebar-theme-title flex-1" style={{ color }}>
        {name}
      </div>

      <div
        className="padding-xxs margin-left-xs d-flex align-items-center rounded"
        style={{ borderStyle: "dashed", borderWidth: 1, borderColor: color }}
      >
        <Icon className={filterIconClassName} style={{ color }} />
      </div>
    </Button>
  );
};

const ContributionsMapThemeBox_theme = graphql__49c4a7d4fa7d2b286008;

export default ContributionsMapThemeBox;
